export default "__VITE_ASSET__BXp9$xfK__"